import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import Mern_Commerce from "../assets/img/Mern_Commerce.png";
import chating_app from "../assets/img/chating_app.png";
import travel_guid from "../assets/img/travel_guid.png";
import shanhost from "../assets/img/shan_host.png";
import gymnasium from "../assets/img/gymnasium.png";
import portfolio from "../assets/img/portfolio.png";

export const mern = [
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg1,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg2,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: Mern_Commerce,
    live:"https://metro-e-commerce.netlify.app",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg1,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg2,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg3,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
];

export const reactjs = [
  {
    title: "Mern Stack E-Commerce",
    description: "Design & Development With ReactJs",
    imgUrl: chating_app,
    live:"https://gleeful-youtiao-348f65.netlify.app",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Travel Guide Agency Startup",
    description: "Design & Development With ReactJs",
    imgUrl: travel_guid,
    live:"https://ema-jhon-auth-2142d.web.app",
    github: "https://github.com/shahinooriatc/travel-guide-client",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg3,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg1,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg2,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg3,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
];

export const html = [
  {
    title: "Shan Host Web service Provider Agency",
    description: "Welcome to Shan. One Stop Web Hosting Solutions",
    imgUrl: shanhost,
    live:"https://shahinooriatc.github.io/ShahHost-Web-Service-provider-landing-page/index.html#",
    github: "https://github.com/shahinooriatc/ShahHost-Web-Service-provider-landing-page",
  },
  {
    title: "Business Startup",
    description: "Static HTML With CSS and JavaScript",
    imgUrl: gymnasium,
    live:"https://shahinooriatc.github.io/GYMNASIUM_LANDING_PAGE/",
    github: "https://github.com/shahinooriatc/GYMNASIUM_LANDING_PAGE",
  },
  {
    title: "Static Portfolio Web Developer",
    description: "Design with HTML and CSS",
    imgUrl: portfolio,
    live:"https://shahinooriatc.github.io/Personal-Portfolio-website/",
    github: "https://github.com/shahinooriatc/Personal-Portfolio-website",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg1,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg2,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
  {
    title: "Business Startup",
    description: "Design & Development",
    imgUrl: projImg3,
    live:"https://www.facebook.com/Shahin143alom",
    github: "https://github.com/shahinooriatc",
  },
];
